function CustomerSupport() {
  return (
    <div>
      <h1 style={{ margin: "0 auto", color: "blue" }}>Welcome to Customer Support Page</h1>
    </div>
  );
}

export default CustomerSupport;
